module.exports = __webpack_public_path__ + "static/media/tarot-card-12.0640cfc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/tarotcards/tarot-card-12.jpg
// module id = 1545
// module chunks = 0